import { useCallback } from 'react';
import useArrayFilters from 'hooks/useArrayFilters';
import DropdownSelect from 'components/DropdownSelect';
import { SandboxStatusTypes } from 'SandboxModule/constants';

const sandboxStatusList = Object.values(SandboxStatusTypes);

const useSandboxStatusSelector = ({
  variant = 'standard',
}: { variant?: 'standard' | 'outlined' } = {}) => {
  const { items, selectedItems, onSelect, clearSelection, isMultiSelect } = useArrayFilters({
    items: sandboxStatusList,
  });

  const handleClearSelectedStatuses = useCallback(() => {
    clearSelection();
  }, [clearSelection]);

  const SandboxStatusSelector = (
    <DropdownSelect
      inputLabel={'Status'}
      items={items}
      itemHash={null}
      selectedItems={selectedItems}
      onSelect={onSelect}
      isMultiSelect={isMultiSelect}
      variant={variant}
    />
  );

  return {
    selectedStatuses: selectedItems,
    SandboxStatusSelector,
    handleClearSelectedStatuses,
  };
};

export default useSandboxStatusSelector;
